<!-- src/components/SolutionDetail.vue -->
<template>
  <div class="wrapper">
    <h1>{{ $t('home.solution.title') }}</h1>

    <div class="section">
      <h2>1. {{ $t('home.solution.system_structure') }}</h2>

      <div class="device-tags">
        <span 
          v-for="(device, idx) in $t('home.solution.devices', { returnObjects: true })" 
          :key="idx" 
          class="device-tag"
        >
          {{ device }}
        </span>
      </div>

      <div v-for="(comp, cIdx) in $t('home.solution.components', { returnObjects: true })" :key="cIdx">
        <h3>{{ comp.name }}</h3>
        <p>{{ comp.desc }}</p>
        <ul v-if="comp.features">
          <li v-for="(f, fIdx) in comp.features" :key="fIdx">{{ f }}</li>
        </ul>
      </div>
    </div>

    <div class="section">
      <h2>2. {{ $t('home.solution.scenario_logic') }}</h2>

      <div class="scenario" v-for="(sc, sIdx) in $t('home.solution.scenarios', { returnObjects: true })" :key="sIdx">
        <div class="scenario-title">{{ sc.title }}</div>
        <div class="scenario-flow">{{ sc.flow }}</div>
      </div>
    </div>

    <div class="section">
      <h2>3. {{ $t('home.solution.advantages_title') }}</h2>
      <ul>
        <li v-for="(adv, aIdx) in $t('home.solution.advantages', { returnObjects: true })" :key="aIdx">
          {{ adv }}
        </li>
      </ul>
    </div>

    <div class="section">
      <h2>4. {{ $t('home.solution.tips_title') }}</h2>
      <ul>
        <li v-for="(tip, tIdx) in $t('home.solution.tips', { returnObjects: true })" :key="tIdx">
          {{ tip }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SolutionDetail'
}
</script>

<style scoped>
.wrapper {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}
.section {
  margin-bottom: 40px;
}
h1, h2, h3 {
  color: #2c3e50;
  margin-bottom: 16px;
}
p {
  margin-bottom: 12px;
}
.device-tags {
  margin: 12px 0;
}
.device-tag {
  display: inline-block;
  padding: 6px 12px;
  font-size: 0.95rem;
  color: #fff;
  background: #409eff;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 8px;
}
.scenario {
  margin-bottom: 24px;
}
.scenario-title {
  font-weight: bold;
  margin-bottom: 8px;
}
.scenario-flow {
  padding: 12px;
  background: #eaf4ff;
  border-left: 4px solid #409eff;
  border-radius: 4px;
}
@media (max-width: 600px) {
  .wrapper {
    padding: 10px;
  }
  .device-tag {
    font-size: 0.85rem;
    padding: 4px 8px;
  }
}
</style>
